import { render, staticRenderFns } from "./kayip.vue?vue&type=template&id=4f1f9618"
import script from "./kayip.vue?vue&type=script&lang=js"
export * from "./kayip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports